/// <reference path="./vite-env.d.ts" />

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { Toaster } from "react-hot-toast";
import App from "./App.tsx";
import { appName } from "./utils/env";
import "./index.css";

document.title = appName();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 6000, // Default 6 seconds (longer than before)
            style: {
              background: "#363636",
              color: "#fff",
            },
            // Specific durations for different types
            success: {
              duration: 4000, // Success messages: 4 seconds
              style: {
                background: "#059669", // Green color for success
                color: "#fff",
              },
            },
            error: {
              duration: 8000, // Error messages: 8 seconds (much longer)
              style: {
                background: "#dc2626", // Red color for errors
                color: "#fff",
              },
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
